import { registerPlugin } from '@capacitor/core';

/**
 * Bridge to the native iOS Share Extension (ShareExtension target, see
 * ios/App/ShareExtension). The extension stores the shared URL/text in the
 * App Group's UserDefaults and opens the host app; this plugin reads it
 * back and clears it. No-op (never called) on web/Android.
 */
const TofBoxShare = registerPlugin('TofBoxSharePlugin');

export default TofBoxShare;
